export const genderOptions: Array<string> = ['Select a gender', 'Female', 'Male', 'Other', 'Not available'];
